var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-down_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "arrow-down_svg__arrow-down"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0a.996.996 0 0 0 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59a.996.996 0 1 0-1.41-1.41L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1",
    className: "arrow-down_svg__vector"
  }))));
};
export { SvgArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIj48ZyBjbGFzcz0iYXJyb3ctZG93biI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMTEgNXYxMS4xN2wtNC44OC00Ljg4Yy0uMzktLjM5LTEuMDMtLjM5LTEuNDIgMGEuOTk2Ljk5NiAwIDAgMCAwIDEuNDFsNi41OSA2LjU5Yy4zOS4zOSAxLjAyLjM5IDEuNDEgMGw2LjU5LTYuNTlhLjk5Ni45OTYgMCAxIDAtMS40MS0xLjQxTDEzIDE2LjE3VjVjMC0uNTUtLjQ1LTEtMS0xcy0xIC40NS0xIDFaIiBjbGFzcz0idmVjdG9yIi8+PC9nPjwvc3ZnPg==";